module.exports = __webpack_public_path__ + "img/er.5e69c8ba.png";